import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import Breadcrumb from './components/Breadcrumb.jsx';

const inner_breadcrumb_container = document.querySelector('.breadcrumb-container-box');

function App() {

    return (
        <div className='breadcrumb-container'>
            <Breadcrumb />
        </div>
    );
}

if (inner_breadcrumb_container) {
    document.body.classList.add('react-breadcrumb');
    ReactDOM.render(<App />, inner_breadcrumb_container);
}
